import styled from '@emotion/styled'
import tw from 'twin.macro'
import InfoPanel from '#src/common/components/info-panel'

export const DisclaimerPanel = styled(InfoPanel)`
  ${tw`lg:w-full mx-auto mb-16`}
`
